/* WF v30 (19.10.2026): Tracking erst nach Cookie-Zustimmung (DSGVO/TTDSG).
   Ersetzt das bisher fest eingebaute Google-Tag-Manager-Snippet und das doppelte gtag.js (G-TP778T7EEB)
   in layout/theme.liquid. GA4, Google-Ads-Conversion, Conversion-Linker und Facebook-Pixel laufen
   alle über GTM-WWR98547 und werden jetzt erst geladen, wenn der Besucher im Shopify-Cookie-Banner
   Marketing erlaubt hat ("Akzeptieren" oder in den Einstellungen Marketing an).
   Außerhalb der Banner-Regionen erlaubt Shopify automatisch -> GTM lädt wie bisher.
   Zusätzlich Google Consent Mode v2: Standard "denied", Update nach der Wahl.
   Unten: kompaktere Optik für das Shopify-Cookie-Banner (Akzeptieren grün hervorgehoben,
   Ablehnen bleibt gleich groß und sichtbar). */
(function () {
  'use strict';
  var w = window, d = document;
  w.dataLayer = w.dataLayer || [];
  function gtag() { w.dataLayer.push(arguments); }
  w.gtag = w.gtag || gtag;
  gtag('consent', 'default', {
    ad_storage: 'denied',
    analytics_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500
  });

  var loaded = false;
  function loadGTM() {
    if (loaded) return;
    loaded = true;
    w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var s = d.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WWR98547';
    var f = d.getElementsByTagName('script')[0];
    f.parentNode.insertBefore(s, f);
  }

  function apply() {
    var cp = w.Shopify && w.Shopify.customerPrivacy;
    if (!cp || typeof cp.marketingAllowed !== 'function') return;
    var a = !!cp.analyticsProcessingAllowed();
    var m = !!cp.marketingAllowed();
    gtag('consent', 'update', {
      analytics_storage: a ? 'granted' : 'denied',
      ad_storage: m ? 'granted' : 'denied',
      ad_user_data: m ? 'granted' : 'denied',
      ad_personalization: m ? 'granted' : 'denied'
    });
    w.dataLayer.push({ event: 'wf_consent', wf_analytics: a, wf_marketing: m });
    if (m) loadGTM();
  }

  d.addEventListener('visitorConsentCollected', function () { apply(); });

  var tries = 0;
  function init() {
    if (w.Shopify && typeof w.Shopify.loadFeatures === 'function') {
      w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) apply();
      });
      return;
    }
    if (++tries < 40) setTimeout(init, 100);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();

  /* Kompakte Banner-Optik */
  var css =
    '#shopify-pc__banner.shopify-pc__banner__dialog{max-width:540px!important;width:calc(100% - 24px)!important;padding:16px 18px!important;border-radius:12px!important;box-shadow:0 6px 28px rgba(0,0,0,.18)!important;bottom:12px!important}' +
    '#shopify-pc__banner .shopify-pc__banner__wrapper{width:100%!important}' +
    '#shopify-pc__banner__body-title{font-size:15px!important;line-height:1.3!important;margin:0 0 6px!important;font-weight:700!important}' +
    '#shopify-pc__banner .shopify-pc__banner__body p{font-size:12.5px!important;line-height:1.45!important;margin:0!important;color:#444!important}' +
    '#shopify-pc__banner__body-policy-link{font-size:12.5px!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns{display:flex!important;flex-wrap:wrap!important;gap:8px!important;margin-top:12px!important;align-items:stretch!important}' +
    '#shopify-pc__banner .shopify-pc__banner__btns button{flex:1 1 0!important;min-width:0!important;width:auto!important;height:auto!important;min-height:40px!important;margin:0!important;padding:8px 10px!important;font-size:13.5px!important;line-height:1.2!important;border-radius:8px!important;font-weight:600!important}' +
    '#shopify-pc__banner__btn-manage-prefs{order:1!important;background:#fff!important;color:#333!important;border:1px solid #cfcfcf!important}' +
    '#shopify-pc__banner__btn-manage-prefs,#shopify-pc__banner__btn-manage-prefs span{font-size:13.5px!important;text-decoration:none!important}' +
    '#shopify-pc__banner__btn-decline{order:2!important;background:#fff!important;color:#333!important;border:1px solid #cfcfcf!important}' +
    '#shopify-pc__banner__btn-accept{order:3!important;flex:1.4 1 0!important;background:#3e774a!important;color:#fff!important;border:1px solid #3e774a!important;font-weight:700!important}' +
    '#shopify-pc__banner__btn-accept:hover{background:#2f6a3c!important}' +
    '@media (max-width:480px){#shopify-pc__banner.shopify-pc__banner__dialog{padding:14px!important;bottom:8px!important}#shopify-pc__banner .shopify-pc__banner__body p{font-size:12px!important}#shopify-pc__banner .shopify-pc__banner__btns button{flex:1 1 45%!important;min-height:38px!important}#shopify-pc__banner__btn-accept{flex:1 1 100%!important;order:0!important}}';
  var st = d.createElement('style');
  st.id = 'wf-consent-css';
  st.appendChild(d.createTextNode(css));
  (d.head || d.documentElement).appendChild(st);
})();
